module.exports = __webpack_public_path__ + "static/media/bgKeops.d311512c.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/bgKeops.png
// module id = 1267
// module chunks = 0